
import {defineComponent} from 'vue';
import ScreenWrapper from "@/components/elements/ScreenWrapper.vue";
import {useState} from "@/hooks/state";
import {ScreenTwoAnswers} from "@/Screens.types";
import ActionButton from "@/components/elements/ActionButton.vue";
import BackNextButtons from "@/components/elements/BackNextButtons.vue";

const state = useState();
export default defineComponent({
  components: {
    // BackNextButtons,
    ActionButton,
    ScreenWrapper
  },
  props: {
    msg: String,
    goTo: Function,
    config: Object as () => ScreenTwoAnswers,
  },

  setup() {
    return {
      state
    }
  },
  data() {
    return {
      screen: this.config.screenId,
      showNicknameModal: false,
      showQuestion: false,
      result: state.answers.value?.[this.config.answerKey],
    }
  },

  mounted() {

  },

  computed: {
    selectedAnswer() {
      return this.state.answers.value?.[this.config.answerKey];
    }
  },

  methods: {
    next() {
      this.goTo(this.config.screenNext)
    }, back() {
      this.goTo(-1)
    },
    answer(answer: string, texts: object) {
      state.setAnswer(this.config.answerKey, answer, {
        [this.config.answerKey]: this.$t(this.config.question),
        ...texts
      });
      this.next();
    }
  }
});
